import { APIContext, useAPIRequest } from "@certn/legacy-api";
import { useCallback, useContext, useState } from "react";
import { useSWRConfig } from "swr";

export function useAuth() {
  const { setToken, clearToken } = useContext(APIContext);
  const request = useAPIRequest();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { cache } = useSWRConfig();

  const login = useCallback(
    async (verification_token: string) => {
      setIsLoading(true);

      try {
        const { token } = await request<{ token: string }>(
          "/internal/people/auth/auth-token/exchange/",
          {
            method: "POST",
            body: JSON.stringify({ verification_token }),
          }
        );
        // delete user data from cache
        cache.delete("/internal/people/me/");
        setToken(token);
        setIsLoading(false);
      } catch (e) {
        setIsLoading(false);
        throw e;
      }
    },
    [setIsLoading]
  );

  const logout = useCallback(() => {
    cache.delete("/internal/people/me/");
    sessionStorage.clear();
    clearToken();
  }, []);

  return { login, logout, isLoading };
}
